import React from 'react'
import PropTypes from 'prop-types'
import styles from './Section6.module.scss'
import Button from '@components/buttons/Button'
import GroupButtons from '@components/group_buttons/GroupButtons'
import { logo, serverMonitoring, smallBuildings } from '@images'
import { Fade, Reveal } from 'react-reveal'

const Section6 = props => {
  const { className, children, title, id, language, buttons } = props
  return (<div id={id} className={[className, styles.container].join(' ')}>
    <div className={['row', styles.centered].join(' ')}>
      <div className={['col-sm-7', styles.contentWrapper].join(' ')}>
        <Fade big top>
          <div className='d-none d-md-block'>
            <img className="d-block mb-3" src={logo} alt="tsplus logo" width="232"/>
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.content}>
            {children}
          </div>
          {buttons}
        </Fade>
      </div>
      <div className="col-sm-5 text-center d-none d-md-block">
        <Fade bottom>
          <img className={styles.mobileWebEdition} src={serverMonitoring} alt="tsplus application screenshot"/>
        </Fade>
      </div>
    </div>
    <div className={styles.shapes}>
      <div className={styles.image}>
        <Reveal>
          <img src={smallBuildings} alt="small buildings background"/>
        </Reveal>
      </div>
    </div>
  </div>)
}

Section6.propTypes = {
  className: PropTypes.any,
  children: PropTypes.any,
  title: PropTypes.any,
  id: PropTypes.string
}

export default Section6
